export default __webpack_public_path__ + "static/media/peopleIcon.d2962cc4.svg";